




























































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Ref, Prop, Watch, Emit } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoCancelamentoStore from '@/components/SolicitacaoCancelamento/Store/SolicitacaoCancelamentoStore'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { onlyNumber, maskMoney, maskDate } from '@/utils/common'
import EventBus from '@/plugins/EventBus'
import { TipoDocumentoUpload, GrupoOpmeTipoEnum } from '@/types/_'
import { Carater } from '@/types/interfaces/Solicitacao'

@Component

export default class ComponenteBackofficeCotacaoOperadoraSuprimentos extends Vue {
  @Prop({ required: true }) disabled: boolean
  @Prop({ required: false, default: true }) showBtn: boolean
  @Prop({ required: false, default: false }) disableBtn: boolean
  @Prop({ required: false, default: '' }) errorMessage: string
  @Prop({ required: false, default: false }) necessitaDeProfissionalAdicional: boolean
  @Prop({ required: true, default: false }) readOnly: boolean
  @Prop({ required: false, default: false }) tipoMaterial: boolean
  @Prop({ required: true, default: true }) quantidadeAutorizada: boolean
  @Prop({ required: true, default: true }) boasPraticas: boolean
  @Prop({ required: true, default: true }) equipamento: boolean
  @Prop({ required: true, default: true }) precificacao: boolean
  @Prop({ required: true, default: true }) profissional: boolean
  @Prop({ required: true, default: true }) grade: boolean
  @Prop({ required: true, default: true }) cotacao: boolean
  @Prop({ required: true, default: true }) valorNegociado: boolean
  @Prop({ required: true, default: true }) valorTotal: boolean
  @Prop({ required: true, default: true }) hisConsignado: boolean
  @Prop({ required: true, default: true }) hisCompra: boolean
  @Prop({ required: true, default: true }) hisSap: boolean

  @Prop({ required: true, default: false }) codigoHospitalDisabled: boolean
  @Prop({ required: true, default: false }) cotacaoDisabled: boolean
  @Prop({ required: true, default: false }) valorUnitarioDisabled: boolean
  @Prop({ required: true, default: true }) valorNegociadoDisabled: boolean
  @Prop({ required: false, default: false }) necessitaDeProfissionalAdicionalDisabled: boolean
  @Prop({ required: false, default: false }) precificacaoDisabled: boolean
  @Prop({ required: true, default: false }) adicionarItem: boolean
  @Prop({ required: false, default: false }) tipoMaterialDisabled: boolean

  $refs!: {
    valorNegociado: any,
    quantidadeAutorizada: any,
    formSuprimentos: any[],
    formFaturamentoOperadora: any,
  }

  tiposDeMaterial: any[] = [
    { value: 'Opme', text: 'OPME' },
    { value: 'Cme', text: 'CME' },
    { value: 'Medicamento', text: 'Medicamento' },
    { value: 'Equipamento', text: 'Equipamento' },
  ]

  hospitalValorNegociado: boolean = false
  load: boolean = false
  delLoad: string = ''
  codigoUnico: string = ''
  laudos: any[] = []
  filesCotacaoOperadora: any[] = []

  get getTemplate() {
    return this.getBackofficeGlobalStore.template.formulario
  }

  get fornecedorLabel() {
    return this.getTemplate && this.getTemplate.opmes && this.getTemplate.opmes.fornecedorLabel
      ? this.getTemplate.opmes.fornecedorLabel
      : 'fornecedor / marca'
  }

  get hospitalTemValorNegociado() {
    return this.getBackofficeGlobalStore.solicitacao.hospitalInformaCotacaoDeOpmeNaAreaDeSuprimentos
  }

  codigoRules: any = {
    valid: true,
    codigo: [
      v => !!v || 'Campo obrigatório',
      v => this.validarCodigo(v) || 'Campo obrigatório somente na etapa de autorização',
    ],
  }

  valorUnitarioRules: any = {
    valid: true,
    valorUnitario: [v => this.validarValorUnitario(v) || 'Campo obrigatório'],
  }

  valorNegociadoRules: any = {
    valid: true,
    valorNegociado: [v => this.validarValorNegociado(v) || 'Campo obrigatório'],
  }

  cotacaoOperadoraRules: any = {
    valid: false,
    valor: [
      v => this.validate(v) || 'O valor é obrigatório.',
    ],
  }

  faturamentoOperadoraRules: any = {
    valid: false,
    observacao: [v => !!v || 'Campo obrigatório'],
  }

  faturamentoChange() {
    this.getBackofficeGlobalStore.setAllOpmeFazCotacao(this.faturamento)
    this.getBackofficeGlobalStore.setCotacaoOperadorasExtraGrupoObservacao('Outros')
    this.getBackofficeGlobalStore.setCotacaoOperadorasExtraGrupoValor(null)
  }

  get getConfiguracaoOpme() {
    return this.getBackofficeGlobalStore.solicitacao.configuracaoOpme
  }

  get enableCodigoUnico() {
    const { hospitalInformaCotacaoDeOpmeNaAreaDeSuprimentos, configuracaoOpme } = this.getBackofficeGlobalStore.solicitacao
    return !hospitalInformaCotacaoDeOpmeNaAreaDeSuprimentos && configuracaoOpme.fazCodificacaoDeOpme
  }

  get getCodigoUnico() {
    return this.codigoUnico
  }

  set getCodigoUnico(value: string) {
    this.codigoUnico = value
  }

  get showPrivateOPMEField() {
    return this.getTemplate.suprimentosCotacao
      && this.getTemplate.suprimentosCotacao.campos
      && this.getTemplate.suprimentosCotacao.campos.exibeCampoParticular
  }

  formattedPrivateOPMEField(isPrivate) {
    if (typeof isPrivate === 'boolean') {
      return isPrivate ? 'Sim' : 'Não'
    }

    return '-'
  }

  sendCodigoUnico() {
    this.getBackofficeGlobalStore.setCodigoUnico(this.getCodigoUnico)
  }

  clearCodigoUnicoOpmes() {
    this.getBackofficeGlobalStore.setCodigoUnico('')
  }

  validate(v: any) {
    if (this.getTemplate
      && this.getTemplate.suprimentosCotacao
      && this.getTemplate.suprimentosCotacao.campos
      && this.getTemplate.suprimentosCotacao.campos.naoExigeValorDePacote) return true
    return parseFloat(v) > 0
  }

  validarCodigo(value) {
    if (this.getBackofficeGlobalStore.solicitacao.situacao.key === 'EmAutorizacao') return true
    return !!value
  }

  validarValorUnitario(value) {
    if (['EmAutorizacao', 'AguardandoSuprimentos'].includes(this.getBackofficeGlobalStore.solicitacao.situacao.key)) return true
    return parseFloat(value) > 0
  }

  validarValorNegociado(value) {
    if (['EmAutorizacao', 'AguardandoSuprimentos'].includes(this.getBackofficeGlobalStore.solicitacao.situacao.key)) return true
    return parseFloat(value) > 0
  }

  quantidadeAutorizadaRules: any = {
    valid: true,
    quantidadeAutorizada: [v => (v !== null && v !== '') || 'Campo obrigatório'],
  }

  get habilitarGrade() {
    return this.getTemplate && this.getTemplate.opmes && this.getTemplate.opmes.habilitarGrade
  }

  get colspan() {
    return [
      this.tipoMaterial,
      this.quantidadeAutorizada,
      this.equipamento,
      this.precificacao,
      this.profissional,
      this.cotacao,
      this.getConfiguracaoOpme.precificaValorUnitario,
      this.valorNegociado,
      this.valorTotal,
      this.necessitaDeProfissionalAdicional,
      (this.grade && this.habilitarGrade),
      (this.cotacaoOperadoraobservacao && this.habilitarGrade),
    ].filter((e: boolean) => e === true).length
  }

  get getOpmesFornecedor() {
    return this.getBackofficeGlobalStore.solicitacao.opmeFornecedores
  }

  get getOpmes() {
    const { grupoOpmeDaSolicitacao } = this.getBackofficeGlobalStore.solicitacao
    if (grupoOpmeDaSolicitacao && grupoOpmeDaSolicitacao.length > 0) {
      const grupoDoMedico = grupoOpmeDaSolicitacao.filter((grupoOpme: any) => grupoOpme.tipo === GrupoOpmeTipoEnum.GrupoDoMedico)
      const grupoComNecessidadeDeAutorizacao = grupoOpmeDaSolicitacao.filter((grupoOpme: any) => grupoOpme.tipo === GrupoOpmeTipoEnum.GrupoComNecessidadeDeAutorizacao)

      return { grupoDoMedico, grupoComNecessidadeDeAutorizacao }
    }
    return { grupoDoMedico: [], grupoComNecessidadeDeAutorizacao: [] }
  }

  get grupoOpmeApi() {
    return this.getBackofficeGlobalStore.grupoOpmeApi
  }

  mesmaDescricao(firstString: string, secondString: string) {
    return (!!firstString && !!secondString) && String(firstString).trim().toUpperCase() !== String(secondString).trim().toUpperCase()
  }

  isQuantidadeAutorizadaValid() {
    const isValid = !this.$refs.quantidadeAutorizada.some(c => c.validate() === false)
    return isValid
  }

  isCodigoHospitalValid() {
    const isValid = !this.$refs.formSuprimentos.some(c => c.validate() === false)
    return isValid
  }

  isValorUnitarioValid() {
    const isValid = !this.$refs.formSuprimentos.some(c => c.validate() === false)
    return isValid
  }

  isValorNegociadoValid() {
    const isValid = !this.$refs.valorNegociado.some(c => c.validate() === false)
    return isValid
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  maskMoneyUtil(value) {
    return maskMoney(value)
  }

  total(id: string) {
    const grupo = this.getBackofficeGlobalStore.solicitacao.grupoOpmeDaSolicitacao.find((e: any) => e.id === id)
    const sum = !grupo
      ? 0
      : grupo.opmes.reduce((acc, curr) => {
        const valorUnitario = !['', 0, null, undefined, NaN].includes(curr.valorUnitario) ? curr.valorUnitario : 0
        const quantidade = !['', 0, null, undefined, NaN].includes(curr.quantidade) ? curr.quantidade : 1
        const soma = acc + (valorUnitario * quantidade)
        return soma
      }, 0)
    return sum
  }

  get operadoraAviso() {
    const { convenioNome, convenioExigeCodificacaoOpme } = this.getBackofficeGlobalStore.solicitacao!
    const textoBase = `Operadora ${convenioNome} exige codificação de material.`
    return convenioExigeCodificacaoOpme ? textoBase : `Operadora ${convenioNome} não exige codificação do material.`
  }

  get loading() {
    return this.load
  }

  set loading(value: boolean) {
    this.load = value
  }

  get delLoading() {
    return this.delLoad
  }

  set delLoading(value: string) {
    this.delLoad = value
  }

  get getLaudos() {
    if (this.getBackofficeGlobalStore.solicitacao.laudos) {
      return this.getBackofficeGlobalStore.solicitacao.laudos.filter(c => c.tipoDocumento === 'CotacaoOpme')
    }

    return []
  }

  set getLaudos(value) {
    this.getBackofficeGlobalStore.setLaudos(value)
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getSolicitacaoCancelamentoStore() {
    return getModule(SolicitacaoCancelamentoStore, this.$store)
  }

  get getShowModal() {
    return this.getBackofficeGlobalStore
  }

  async deleteLaudo(value) {
    this.delLoading = value.id
    const request = await this.getBackofficeGlobalStore.deleteLaudo({
      hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
      id: value.id,
    })
    if (request.success) {
      if (request.success) {
        const removeArray: any[] = []

        for (let i = 0; i < this.getLaudos.length; i++) {
          if (this.getLaudos[i].identifier === value.identifier) {
            removeArray.push(i)
          }
        }

        for (let i = 0; i < removeArray.length; i++) {
          this.getLaudos.splice(removeArray[i], 1)
        }
      }
    }
    this.delLoading = ''
  }

  protocoloOperadoraForm: any = {
    valid: true,
    protocoloOperadora: [
      v => !!v || 'Campo obrigatório.',
    ],
  }

  get hasOpme() {
    return this.getBackofficeGlobalStore.solicitacao.temOpme
  }

  get getDataAutorizacao() {
    if (this.getBackofficeGlobalStore.solicitacao.autorizacaoValidade) {
      return maskDate(this.getBackofficeGlobalStore.solicitacao.autorizacaoValidade)
    }
    return ''
  }

  set getDataAutorizacao(value: string) {
    this.getBackofficeGlobalStore.setAutorizacaoValidade(value)
  }


  get surgerySolicitationHasUrgencyAutorizationEnabled() {
    return this.getBackofficeGlobalStore.solicitacao.utilizaAnalisePreAutorizacaoUrgencia
      && this.getBackofficeGlobalStore.solicitacao.utilizaAguardandoAutorizacaoUrgencia
      && this.surgeryType && this.surgeryType.key === 'Urgencia'
      && (this.surgeryStatus === 'AguardandoAutorizacaoUrgencia' || this.surgeryStatus === 'AnalisePreAutorizacaoUrgencia')
  }

  get surgeryType() {
    return this.getBackofficeGlobalStore.solicitacao.carater as Carater
  }

  get surgeryStatus() {
    return this.getBackofficeGlobalStore.solicitacao.situacao.key
  }

  async inputFileCotacaoOperadora(newFile, oldFile) {
    if (newFile.identifier) {
      return
    }

    EventBus.$emit('loadingAnexoRespotaCotacao', true)

    const form = new FormData()
    form.append('laudos', newFile.file)

    const request = await this.getBackofficeGlobalStore.uploadCotacaoOperadora(form)

    // eslint-disable-next-line no-param-reassign
    newFile.identifier = request.data[0].id
    // eslint-disable-next-line no-param-reassign
    newFile.id = request.data[0].id
    // eslint-disable-next-line no-param-reassign
    newFile.url = request.data[0].url
    // eslint-disable-next-line no-param-reassign
    newFile.nomeOriginalArquivo = request.data[0].nomeOriginalArquivo
    // eslint-disable-next-line no-param-reassign
    newFile.tipoDocumento = TipoDocumentoUpload.CotacaoOpme
    this.getLaudos = newFile

    EventBus.$emit('loadingAnexoRespotaCotacao', false)
  }

  get faturamento() {
    // @ts-ignore
    return this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo
      ? this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo.faturamentoDiretoComOperadora
      : false
  }

  set faturamento(value: boolean) {
    this.getBackofficeGlobalStore.setCotacaoOperadorasExtraGrupoFaturamento(value)
  }

  get comentarios() {
    // @ts-ignore
    return this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo
      ? this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo.comentarios
      : ''
  }

  set comentarios(value: string) {
    this.getBackofficeGlobalStore.setCotacaoOperadorasExtraGrupoComentarios(value)
  }

  get notaFiscal() {
    // @ts-ignore
    return this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo
      ? this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo.notaFiscal
      : false
  }

  set notaFiscal(value: boolean) {
    this.getBackofficeGlobalStore.setCotacaoOperadorasExtraGrupoNotaFiscal(value)
  }

  get cotacaoOperadoraobservacao() {
    // @ts-ignore
    return this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo
      ? this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo.observacao
      : 'Outros'
  }

  set cotacaoOperadoraobservacao(value: string) {
    this.getBackofficeGlobalStore.setCotacaoOperadorasExtraGrupoObservacao(value)
  }

  get cotacaoComUrgencia() {
    // @ts-ignore
    return this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo
      ? this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo.cotacaoComUrgencia
      : false
  }

  set cotacaoComUrgencia(value: boolean) {
    this.getBackofficeGlobalStore.setCotacaoOperadorasExtraGrupoCotacaoComUrgencia(value)
  }

  get valor() {
    if (this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo) {
      return this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo.valor === null ? 0 : this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo.valor
    }
    return 0
  }

  set valor(value: string | number | null) {
    this.getBackofficeGlobalStore.setCotacaoOperadorasExtraGrupoValor(value)
  }

  clearCodigoUnico() {
    this.codigoUnico = ''
  }

  setLoading(value:boolean) {
    this.loading = value
  }

  hasCodigoHospital(suprimentoId: string, opmeId: string) {
    const grupoOPMEApi = this.grupoOpmeApi.find((e: any) => e.id === suprimentoId)
    const grupoOPME = this.getBackofficeGlobalStore.solicitacao.grupoOpmeDaSolicitacao.find((e: any) => e.id === suprimentoId)
    // @ts-ignore
    if (grupoOPME !== undefined && grupoOPMEApi !== undefined) {
      // @ts-ignore
      const opmeApi = grupoOPMEApi.opmes.find((e: any) => e.opmeId === opmeId)
      // @ts-ignore
      const opme = grupoOPME.opmes.find((e: any) => e.opmeId === opmeId)
      if (opme && opmeApi) {
        // @ts-ignore
        return !['', undefined, null].includes(opme.codigoHospital) && !['', undefined, null].includes(opmeApi.codigoHospital)
      }
    }
    return false
  }

  mounted() {
    EventBus.$on('loadingAnexoRespotaCotacao', value => this.setLoading(value))
  }
}
